import { Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'
import type { GlobalBreadcrumbsProps } from './GlobalBreadcrumbs'
import GlobalBreadcrumbs from './GlobalBreadcrumbs'
import PageContainer from './PageContainer'

interface Props {
  title: ReactNode
  breadcrumbs: GlobalBreadcrumbsProps
  actions?: ReactNode
}

// Recommended MUI Layouting from Toolpad interface style: https://mui.com/toolpad/core/react-page-container/
const PageHeader = ({ breadcrumbs, title, actions }: Props) => {
  return (
    <PageContainer disableBottomGutter sx={{ paddingBottom: 1 }}>
      <GlobalBreadcrumbs path={breadcrumbs.path} current={breadcrumbs.current} />
      <Stack direction={{ xs: 'column', md: 'row' }} gap={1}>
        <Typography variant="h4" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        {actions}
      </Stack>
    </PageContainer>
  )
}

export default PageHeader
